<template>
  <div v-if="loaded">
    <FormKit v-model="taskAttrs" type="form" class="mt-4" :actions="false">
      <FormKit type="text" name="name" label="Task Name" />
      <QuillInput
        :model-value="taskAttrs.description"
        name="task-description"
        label="Task Description"
        @update:model-value="value => (taskAttrs.description = value)"
      />
      <FormKit type="textarea" rows="5" label="Embed Code" name="embed_src" placeholder="Enter the embed code here" />
      <FormKit
        type="select"
        label="Assigned to"
        name="assigned_to_role"
        :options="{ agent: 'Agent', other: 'Other' }"
        placeholder="Select a person"
      />
      <FormKit
        v-if="taskAttrs.assigned_to_role === 'other'"
        type="select"
        label="Assigned to"
        name="assigned_to_user_id"
        :options="assignableUsers"
        placeholder="Select a person"
      />
    </FormKit>
  </div>
</template>

<script>
import QuillInput from '../shared/QuillInput.vue';
import { toast } from 'vue-sonner';

export default {
  components: {
    QuillInput,
  },
  props: {
    task: {
      required: true,
      type: Object,
    },
    assignableUsers: {
      required: true,
      type: Array,
    },
  },
  data() {
    return {
      taskAttrs: {
        name: '',
        description: '',
        embed_src: '',
        assigned_to_role: '',
        assigned_to_user_id: '',
      },
      loaded: false,
    };
  },
  async mounted() {
    this.taskAttrs = {
      ...this.taskAttrs,
      ...this.task,
      embed_src: this.task.checklist_taskable.settings?.embed_src,
    };
    this.loaded = true;
  },
  methods: {
    async updateTask() {
      const res = await fetch(`/api/task_checklists/${this.task.task_checklist_id}/checklist_tasks/${this.task.id}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-TOKEN': document.querySelectorAll('[name="csrf-token"]')[0].content,
        },
        body: JSON.stringify({
          checklist_task: {
            name: this.taskAttrs.name,
            description: this.taskAttrs.description,
            assigned_to_role: this.taskAttrs.assigned_to_role,
            assigned_to_user_id: this.taskAttrs.assigned_to_user_id,
            order: this.taskAttrs.order,
            checklist_taskable: {
              embed_src: this.taskAttrs.embed_src,
            },
          },
        }),
      });

      const { status } = await res.json();

      if (status === 'success') {
        const checklistType = this.task.task_checklist.checklist_type;
        await this.$router.push(`/settings/company/${checklistType}_checklists/${this.task.task_checklist_id}/edit`);
        toast.success('Task Updated', {
          action: { label: 'Dismiss' },
          description: 'Your task was successfully updated.  Use the button below to dismiss this alert.',
        });
      }
    },
  },
};
</script>
